import { ReloadOutlined } from '@ant-design/icons-vue';
import Spin from '../spin';
import Button from '../button';
export default function QRcodeStatus({ prefixCls, locale, onRefresh, statusRender, status, }) {
    const defaultExpiredNode = (<>
      <p class={`${prefixCls}-expired`}>{locale === null || locale === void 0 ? void 0 : locale.expired}</p>
      {onRefresh && (<Button type="link" onClick={onRefresh} v-slots={{ icon: () => <ReloadOutlined /> }}>
          {locale === null || locale === void 0 ? void 0 : locale.refresh}
        </Button>)}
    </>);
    const defaultScannedNode = <p class={`${prefixCls}-scanned`}>{locale === null || locale === void 0 ? void 0 : locale.scanned}</p>;
    const defaultNodes = {
        expired: defaultExpiredNode,
        loading: <Spin />,
        scanned: defaultScannedNode,
    };
    const defaultStatusRender = info => defaultNodes[info.status];
    const mergedStatusRender = statusRender !== null && statusRender !== void 0 ? statusRender : defaultStatusRender;
    return <>{mergedStatusRender({ status, locale, onRefresh })}</>;
}
